import { HRMS_API_URL, apiPath } from './apiPath';
import createApiInstance from './createApiInstance';

const api = createApiInstance(HRMS_API_URL);

export const getCalendar = (params) => api.get(apiPath.calendar, { params });
export const viewalendarTaskAPI = (taskId) => api.get(apiPath.viewalendarTask+taskId);
export const createCalendarTaskAPI = (reqPayload) => api.post(apiPath.createCalendarTask, reqPayload);
export const deleteCalendarTaskAPI = (reqPayload) => api.post(apiPath.deleteCalendarTask, reqPayload);